import { Injectable, inject } from '@angular/core'
import { RestClientPaged } from '@elderbyte/ngx-starter'
import { LoggerFactory } from '@elderbyte/ts-logger'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs'
import { environment } from '../../../environments/environment'

export enum WorkItemMigrationCommandType {
  PROCESS_PLANS = 'PROCESS_PLANS',
  RE_EMIT = 'RE_EMIT',
  PREPARE_INVALID = 'PREPARE_INVALID',
  ENRICH_INVALID = 'ENRICH_INVALID',
}

export interface WorkItemMigrationCommand {
  type: WorkItemMigrationCommandType
  sourceProcessPlanId?: string
  targetProcessPlanId?: string
  facility?: string
  workItemIds?: string[]
}

@Injectable({
  providedIn: 'root',
})
export class WorkItemMigrationService extends RestClientPaged<any, string> {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private readonly log = LoggerFactory.getLogger(this.constructor.name)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const http = inject(HttpClient)

    super(environment.apiPath + '/migration/work-item', http, {
      idField: 'id',
    })
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public migrate(body: WorkItemMigrationCommand): Observable<unknown> {
    return this.http.post<any>(this.restEndpoint, body)
  }
}
